import { Route, Routes, useLocation } from "react-router-dom";
// page routes
import Home from "./components/Home/Home";
import Services from "./components/Pages/Services/Services";
import Projects from "./components/Pages/Projects/Projects";
import Contact from "./components/Pages/Contact/Contact";
import About from "./components/Pages/About/About";
import Comming from "./components/comming-soon/comming";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/about-us" element={<About />} />
        <Route path="*" element={<Comming />} />
      </Routes>
    </div>
  );
}

export default App;
